// @module BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes
define('BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes.View'
,	[
	'btm_recentlyvieweditemfixes_recentlyvieweditemfixes.tpl'
	,	'Backbone'
    ]
, function (
	btm_recentlyvieweditemfixes_recentlyvieweditemfixes_tpl
	,	Backbone
)
{
    'use strict';

	// @class BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_recentlyvieweditemfixes_recentlyvieweditemfixes_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new RecentlyViewedItemFixesModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.RecentlyViewedItemFixes.RecentlyViewedItemFixes.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
